import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=36ecd580&scoped=true"
import script from "./baseTable.vue?vue&type=script&lang=js"
export * from "./baseTable.vue?vue&type=script&lang=js"
import style0 from "./baseTable.vue?vue&type=style&index=0&id=36ecd580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ecd580",
  null
  
)

export default component.exports